import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { CoreLink, LanguageSwitcher, RecursiveMenu } from '@uncinc/react-drupal-core';
import { Container, Lottie } from '@uncinc/uncinc-react-kitchen-sink';

import crossLottie from '../../../../assets/lotties/cross.json';
import logoLottie from '../../../../assets/lotties/logo.json';

import './style.scss';

const Logo = React.memo(() => {
  return (
    <Lottie
      id="logo"
      className="UncIncLogo"
      data={logoLottie}
      autoPlay
      loop={false}
      delay={200}
    />
  );
});

const MenuButton = React.memo(({ lottieRef, isOverlayOpen }) => {
  return (
    <Lottie
      ref={lottieRef}
      id="hamburgerOpen"
      data={crossLottie}
      autoPlay={false}
      loop={false}
      direction={1}
      onInit={(instance) => {
        instance.addEventListener('complete', () => {
          instance.setDirection(isOverlayOpen.current ? -1 : 1);
        });
      }}
    />
  );
});

const Header = ({
  isOverlayOpen,
  toggleOverlayOpen,
  menuButtonRef,
  menuTitleRef,
  lottieRef,
}) => {
  const { t } = useTranslation();

  const lang = useSelector((state) => state.getIn(['ui', 'language']));

  return (
    <div className="Header">
      <div className="Header__background">
        <Container>
          <CoreLink
            onClick={() => toggleOverlayOpen(true)}
            className="Header__logo"
            href={`/${lang}`}>
            <Logo />
          </CoreLink>

          <div className="Header__actions">
            <div
              ref={menuButtonRef}
              className="Header__menu show"
            >
              <RecursiveMenu
                menuId="main"
                maxLevel={1}
                onClickFunction={() => toggleOverlayOpen(true)}
              />
            </div>

            <LanguageSwitcher
              languages={{ 'nl': 'NL', 'en': 'EN' }}
              hideActive={false}
            />

            <button
              type="button"
              className="Header__hamburger"
              tabIndex={0}
              onClick={() => toggleOverlayOpen()}
            >
              <div className="Header__label">
                <span>{t('general.close')}</span>
                <span>{t('general.menu')}</span>
              </div>
              <MenuButton
                lottieRef={lottieRef}
                isOverlayOpen={isOverlayOpen}
              />
            </button>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Header;
